<template>
	<article class="layout-3-col-wrapper">
		<div class="left"></div>
		<div :class="`middle ${shelfComponent && 'hidden-sm '}`">
			<div v-if="selectedPollStatus.loading">
				<spinner></spinner>
			</div>
			<div v-if="!selectedPollStatus.loading">
				<div v-if="selectedPollStatus.error">
					<h5>An unexpected error occurred. Please try again.</h5>
				</div>
				<div v-if="selectedPoll && !selectedPoll.isArchived()">
					<router-link :to="{name: 'manage'}" class="arrow-link" >
						<svg width="12px" height="18px" viewBox="0 0 12 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g id="Page-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
								<g id="Artboard" transform="translate(-129.000000, -64.000000)" fill="#337CCA" fill-rule="nonzero">
									<path d="M129.902349,72.3369141 L137.797818,64.7455078 C138.178474,64.3794922 138.795974,64.3794922 139.176631,64.7455078 L140.097599,65.6310547 C140.477849,65.9966797 140.478256,66.5888672 140.099224,66.9552734 L133.841756,72.9998047 L140.098818,79.0447266 C140.478256,79.4111328 140.477443,80.0033203 140.097193,80.3689453 L139.176224,81.2544922 C138.795568,81.6205078 138.178068,81.6205078 137.797412,81.2544922 L129.902349,73.6626953 C129.521693,73.2966797 129.521693,72.7029297 129.902349,72.3369141 Z" id="chevron-left"></path>
								</g>
							</g>
						</svg>
						<span>Back to My Integrations</span>
					</router-link>
					<header>
						<div class="item-logo">
							<img v-bind:src="selectedPoll.marketItem.logo">
						</div>
						<div class="header-title">
							<div>{{selectedPoll.name}}
								<span class="poll-status"><span :class="`${selectedPoll.state}`"></span></span>
								<span class="credits" v-if="selectedPoll.credits"> Using {{ selectedPoll.credits }} Credits </span>
							</div>
								<div class="btn-wrapper">
									<button type="button" :class="`${!shelfComponent &&  'call-to-action' } outline-btn`"  @click="toggleUpdateShelf()">{{ shelfComponent ? 'Quit' : 'Edit Integration'}}</button>
								</div>
							</div>
					</header>

					<section v-if="selectedPoll.marketItem.description" class="section-description">
						<p>{{selectedPoll.marketItem.description}}</p>
					</section>
					<section v-if="selectedPoll.marketItem.templateOptions">
						<Details :item="selectedPoll.marketItem"></Details>
					</section>
				</div>
				<div v-else>
					<h5>This poll has been deleted.</h5>
				</div>
			</div>
		</div>
		<div class="right">
			<component v-if="selectedPoll && !selectedPoll.isArchived()" v-bind:is="shelfComponent" @close="onCloseUpdateShelf" v-bind="shelfProps"></component>
		</div>
	</article>
</template>

<script>
	import Spinner from '../components/Spinner';
	import ItemUpdate from '../components/ItemUpdate';
	import Details from '../components/Details';
	import { mapGetters } from 'vuex';

	export default {
		name: 'PollDetails',
		filters: {},
		data(){
			return {
				shelfComponent: null,
				shelfProps: null,
			};
		},
		components: {
			Spinner,
			Details
		},
		computed: {
			...mapGetters([
				'selectedPoll',
				'selectedPollStatus',
			])
		},
		methods: {
			onCloseUpdateShelf: function() {
				this.shelfComponent = null;
				this.shelfProps = null;
				this.$store.dispatch('POLL_UPDATE_RESET');
			},
			openUpdateShelf: function() {
				this.shelfComponent = ItemUpdate;
				this.shelfProps = {};
			},
			toggleUpdateShelf: function() {
				if (this.shelfComponent) {
					this.onCloseUpdateShelf();
				} else {
					this.openUpdateShelf();
				}
			}
		},
		created() {
			this.$store.dispatch('POLL_DETAILS_REQUEST', { pollId: this.$route.params.pollId, withMarketItem: true });
			this.openUpdateShelf();
		}
	};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.poll-status span.ACTIVE{
		background-color: #06D6A0;
	}
	.poll-status span.INACTIVE{
		background-color: #666;
	}
	.poll-status span.ACTIVE,
	.poll-status span.INACTIVE {
		margin-left: 5px;
		margin-bottom: 2px;
		height: 9px;
		width: 9px;
		border-radius:50%;
		display:inline-block;
	}

.cronReadable{
		text-transform: lowercase;
	}
	.layout-3-col-wrapper {
		display:flex;
		flex: 1 1 auto;
	}

	.left, .right{
		flex-basis:  0;
	}
	.middle{
		max-width: 900px;
		flex-basis: 100%;
	}


	.section-description{
		line-height: 1.5;
	}
	.loading{
		margin-top: 150px;
	}



	.middle{
		/* flex: 1 1 auto; */
		padding-top:40px;

	}

	.arrow-link{
		margin-bottom: 15px;
		display:inline-block;
	}
	.arrow-link i,
	.arrow-link span{
		vertical-align: middle;
	}

	.header-title{
		font-size:24px;
		margin-left:15px;
		display:flex;
		flex-direction: column;
		justify-content: space-between;
		height:80px;
	}
	header{
		display:flex;
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
		margin-top:15px;
		margin-bottom:5px;
	}
	header h1{
		flex-grow: 1;
		margin-left:10px;
	}
	header .item-logo{
		height: auto;
		width: 80px;
		height: 80px;
		display:flex;
		background-color: #f1f3f6;
		box-shadow: 5px 5px 10px 0 rgba(61,66,67,0.05);
		text-align:center;
		border: .66px solid white;
	}

	h3{
		font-weight:300;
	}


	/* // Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
	.hidden-sm{
		display:none;
	}
	.middle{
		width:100%;
		flex-basis:100%;
	}
	.right{
		flex-basis:100%;
		padding-bottom: 20px;
		/* height:100%; */
		min-width: 350px;
	}
	.right:empty{
		flex-basis:0;
		padding-bottom: 0;
		min-width:0;
	}

	.configuration-panel{
		margin-left: 0;
	}

	.left{
		flex-basis: 0;
	}
	.details-content{
		padding:0 15px 15px;
	}



  }

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {
	.hidden-sm{
		display:none;
	}

	.details-content{
		padding:0 15px 15px;

	}
	.middle{
		width:100%;
		flex-basis:100%;
	}

	/* .layout-3-col-wrapper{
		flex-direction: column-reverse;
	} */
	.right{
		flex-basis:100%;
		padding-bottom: 20px;
	}
	.right:empty{
		flex-basis:0;
		padding-bottom: 0;

	}
	.configuration-panel{
		margin-left: 0;
	}
	.left{
		flex-basis: 0;
	}


}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
	.visible-xs, .visible-sm{
		display:none;
	}
}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
	.visible-xs, .visible-sm{
		display:none;
	}
}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
	.visible-xs, .visible-sm{
		display:none;
	}

}

.header-title .credits {
	font-size: 12px; color: #444;
}

.header-title .btn-wrapper {
	margin-top:10px;
}
</style>



// WEBPACK FOOTER //
// src/views/PollDetails.vue